/**
 * SEO-сторінки: шляхи мають збігатися з routes та з STATIC_PATHS у scripts/generate-sitemap.cjs
 */
export const SEO_LANDING_NAV = [
  {
    path: '/komplektuyuchi-ventylyatsiyi-kondytsionuvannya',
    label: 'Комплектуючі для вентиляції та кондиціонування повітря'
  },
  { path: '/reshitky-ta-dyfuzzory', label: 'Вентиляційні решітки та дифузори' },
  { path: '/povitroprovody-ventylyatsiya', label: 'Повітропроводи для вентиляції' },
  { path: '/komplektuyuchi-ventylyatsiyi-kuputy-kyyiv', label: 'Купити комплектуючі в Києві' },
  { path: '/montazh-ta-servis-ventylyatsiyi', label: 'Монтаж та сервіс вентиляції' }
] as const

export const SEO_LANDING_PATHS = SEO_LANDING_NAV.map((item) => item.path)

export type SeoLandingPath = (typeof SEO_LANDING_NAV)[number]['path']
